/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'dashboard-icon': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M9.25 10c.917 0 1.671.708 1.744 1.607l.006.143v10.5c0 .917-.708 1.671-1.607 1.744L9.25 24h-7.5a1.752 1.752 0 01-1.744-1.607L0 22.25v-10.5c0-.917.708-1.671 1.607-1.744L1.75 10h7.5zm5.5 6h7.5c.917 0 1.671.708 1.744 1.607l.006.143v4.5c0 .917-.708 1.671-1.607 1.744L22.25 24h-7.5a1.752 1.752 0 01-1.744-1.607L13 22.25v-4.5c0-.917.708-1.671 1.607-1.744L14.75 16h7.5zm7.5-16C23.215 0 24 .785 24 1.75v10.5c0 .965-.785 1.75-1.75 1.75h-7.5c-.965 0-1.75-.785-1.75-1.75V1.75C13 .785 13.785 0 14.75 0zm-13 0c.917 0 1.671.708 1.744 1.607L11 1.75v4.5c0 .917-.708 1.671-1.607 1.744L9.25 8h-7.5A1.752 1.752 0 01.006 6.393L0 6.25v-4.5C0 .833.708.079 1.607.006L1.75 0h7.5z" _fill="#FFF" fill-rule="evenodd"/>'
  }
})
